module.exports = __webpack_public_path__ + "static/media/anni_top.d30b4e70.png";